// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-input--switch .v-input__slot{display:flex;flex-direction:row-reverse;justify-content:flex-end}.v-input--switch .v-input__slot .v-input--selection-controls__input{margin-left:.75em}", ""]);
// Exports
module.exports = exports;
